<template>
  <div style="background: #fff;height: 100%">
    <div>
      <div class="title1">添加公司银行卡</div>
      <div class="title2">请添加公司名下的银行卡</div>
    </div>
    <div>
      <div class="lineBox flex borderT">
        <div class="title">公司名称</div>
        <div class="flex1">
          <input
            class="lineInput"
            disabled="disabled"
            v-model="params.name"
            placeholder="请输入公司名称"
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">银行卡号</div>
        <div class="flex1">
          <input
            class="lineInput"
            v-model="params.accountNumber"
            @blur="getBankName"
            placeholder="请输入银行卡号"
          />
        </div>
      </div>
      <div class="lineBox flex">
        <div class="title">开户银行</div>
        <div class="flex1" @click="openPop">
          <input
            class="lineInput"
            placeholder="请选择开户银行"
            disabled="true"
            v-model="bankName"
          />
        </div>
      </div>
      <div class="inputWapper protocol">
        <CheckImgbox v-model="checked" class="checkbox-style" />
        <div class="protocol-text">
          请阅读并同意<a
            class="protocol-link"
            href="/policy/service_policy.html"
            @click="watchServe"
            >《电商业务服务协议》</a
          >
        </div>
      </div>
    </div>
    <div class="addButton" @click="add">添加</div>

    <div v-transfer-dom>
      <popup v-model="show">
        <div class="popup0">
          <div class="uni-padding-wrap flex">
            <div class="uni-title flex1">
              选择支行：<span v-if="bankContacts.length > 0">{{
                bankContacts[bankContactIndex].name
              }}</span>
            </div>
            <div @click="sure">确认</div>
          </div>
          <div class="searchBox flex">
            <input
              class="searchInput flex1"
              placeholder="搜索字段"
              v-model="search.name"
            />
            <span @click="searchBank">搜索</span>
          </div>
          <picker
            :data="pickerList"
            v-model="pickerValue"
            @on-change="changeBankContactName"
          ></picker>
        </div>
      </popup>
    </div>
  </div>
</template>

<script>
import { bankCompanyCreate, bankList } from "../../api/company";
import CheckImgbox from "@/components/CheckImgbox";
import { TransferDom, Popup, Picker } from "vux";
import { getCompanyDetail } from "../../api/identify";

export default {
  directives: {
    TransferDom
  },
  components: {
    Picker,
    Popup,
    CheckImgbox
  },
  data() {
    return {
      params: {
        accountNumber: "",
        bankName: "",
        companyId: "",
        name: "",
        requestNo: new Date().getTime(),
        bankCode: "",
        clientId: ""
      },
      bankContacts: [],
      bankContactIndex: 0,
      bankContactValue: "",
      pickerValue: [],
      pickerList: [],
      search: {
        name: ""
      },
      show: false,
      bankName: "",
      checked: false,
      companyId: ""
    };
  },
  onShow() {
    let that = this;
    const res = this.$ls.get("accountNumber");
    if (res.data) {
      that.params.accountNumber = res.data;
    }
  },
  created() {
    this.params.clientId = this.$store.state.user.userInfo.id;
    this.companyId = this.$route.params.companyId;
    this.getCompanyDetail();
  },
  mounted() {
    this.getBankList();
  },
  methods: {
    watchServe() {
      this.$ls.set("accountNumber", this.params.accountNumber);
      location.href = "/policy/service_policy.html";
    },
    openPop() {
      this.show = true;
    },
    getBankName() {
      this.$ls.set("accountNumber", this.params.accountNumber);
    },
    sure() {
      this.bankName = this.bankContacts[this.bankContactIndex].name;
      this.params.bankName = this.bankContacts[this.bankContactIndex].name;
      this.params.bankCode = this.bankContacts[this.bankContactIndex].code;
      this.search.name = "";
      this.show = false;
    },
    searchBank() {
      this.pickerList = [];
      this.bankContactIndex = 0;
      this.getBankList();
    },
    changeBankContactName(e) {
      this.bankContactValue = e;
      for (let i = 0; i < this.bankContacts.length; i++) {
        if (this.bankContacts[i].code == this.bankContactValue) {
          this.bankContactIndex = i;
        }
      }
    },
    getBankList() {
      bankList(this.search)
        .then(res => {
          this.bankContacts = res;
          let a = [];
          for (let i = 0; i < res.length; i++) {
            a.push({ name: res[i].name, value: res[i].code });
          }
          this.pickerList.push(a);
        })
        .catch(err => {
          this.$showError(err);
        });
    },

    checkboxChange(e) {
      this.checked = e.detail.value.length > 0;
    },
    add() {
      if (this.checked == false) {
        this.$showError("请先阅读并同意相关协议");
      } else if (!this.params.bankCode) {
        this.$showError("请选择开户银行");
      } else {
        this.$vux.loading.show();
        bankCompanyCreate(this.params)
          .then(() => {
            this.$vux.loading.hide();
            this.$ls.remove("accountNumber");
            this.$router.push({ path: "/bankCard/bankCard?topIndex=1" });
          })
          .catch(err => {
            this.$vux.loading.hide();
            this.$ls.remove("accountNumber");
            this.$showError(err);
          });
      }
    },

    getCompanyDetail() {
      getCompanyDetail({ companyId: this.companyId })
        .then(res => {
          this.params.name = res.companyName;
          this.params.companyId = res.id;
        })
        .catch(err => {
          this.$showError(err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.popup0 {
  background: #fff;
  padding-bottom: 15px;
  height: 800px;
}
.checkbox-style {
  width: 32px;
  height: 32px;
  margin-right: 20px;
  display: inline-block;
  vertical-align: middle;
}
.protocol-text {
  display: inline;
}
input {
  width: 100%;
  border: none;
  background: #fff;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.protocol-text {
  display: inline;
}
.inputWapper {
  align-items: center;
  margin: 30px 60px 0 60px;
  border-bottom: 1px solid #e2e2e2;
  padding-bottom: 12px;
  overflow: hidden;
  &.protocol {
    border: none;
    font-size: 12px;
    color: #bfbfbf;
    .protocol-link {
      font-size: 11px;
      color: #007bec;
    }
  }
}
.title1 {
  text-align: center;
  font-size: 20px;
  line-height: 40px;
  padding: 90px 0 40px 0;
  font-weight: bold;
}
.title2 {
  text-align: center;
  font-size: 15px;
  line-height: 30px;
  padding-bottom: 90px;
}
.borderT {
  border-top: 1px solid #e8e8e8;
}
.lineBox {
  margin: 0 50px;
  height: 50px;
  line-height: 50px;
  padding: 24px 16px;
  border-bottom: 1px solid #e8e8e8;
}
.title {
  font-size: 15px;
}
.lineInput {
  height: 50px;
  line-height: 50px;
  text-align: right;
  color: #474747;
  font-size: 14px;
}
.codeButton {
  width: 160px;
  height: 50px;
  line-height: 50px;
  text-align: right;
  font-size: 14px;
  border-left: 1px solid #e8e8e8;
  color: #1573ff;
  margin-left: 20px;
}
.addButton {
  margin: 100px 50px 0;
  text-align: center;
  font-size: 16px;
  height: 88px;
  line-height: 88px;
  background: #007bec;
  color: #fff;
  border-radius: 10px;
}

.searchBox {
  font-size: 14px;
  padding: 40px;
  height: 64px;
  line-height: 64px;
}
.searchInput {
  height: 64px;
  line-height: 64px;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 0 20px;
  margin-right: 20px;
}
uni-picker-view {
  display: block;
}

uni-picker-view .uni-picker-view-wrapper {
  display: flex;
  position: relative;
  overflow: hidden;
  height: 100%;
  background-color: white;
}

uni-picker-view[hidden] {
  display: none;
}

picker-view {
  width: 100%;
  height: 600px;
  margin-top: 20px;
}
.item {
  line-height: 100px;
  font-size: 16px;
  text-align: center;
}
.uni-padding-wrap {
  padding: 40px;
  font-size: 16px;
}
</style>
